export enum MembershipTabs {
  myplans = 'myplans',
  creditcard = 'creditcard',
}

export enum CreditCardTabs {
  cardList = 'Credit Card',
  addCard = 'Add Credit Card',
}
